module.exports = __webpack_public_path__ + "img/winner-daily.cf52c58a.png";